"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var reactive_storelocator_1 = require("@dotdev/reactive-storelocator");
var next_components_1 = require("@dotdev/next-components");
var StoreDetail = /** @class */ (function (_super) {
    __extends(StoreDetail, _super);
    function StoreDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentLocation: null,
            currentStore: null,
            loading: true
        };
        _this.renderLocationInfoWindow = function (location, mapMarker) {
            if (mapMarker === void 0) { mapMarker = false; }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "" + (mapMarker ? "w-full py-4 font-medium" : "pt-0-4 pb-0-6") },
                    React.createElement("p", { className: "text-xs text-black font-semibold uppercase tracking-1" }, location.attributes.shopName)),
                React.createElement("div", { className: "" + (mapMarker ? "w-full" : "") },
                    React.createElement("p", { className: "text-black leading-normal text-sm pb-0-6" },
                        location.attributes.address2 ? (React.createElement(React.Fragment, null,
                            location.attributes.address1,
                            ",",
                            React.createElement("br", null),
                            location.attributes.address2,
                            ",",
                            location.attributes.suburb)) : (React.createElement(React.Fragment, null,
                            location.attributes.address1,
                            ",",
                            location.attributes.suburb,
                            ",")),
                        React.createElement("br", null),
                        location.attributes.state,
                        " ",
                        location.attributes.postcode,
                        location.attributes.shopPhone ? (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("a", { href: "tel:" + location.attributes.shopPhone.replace("(", "").replace(")", "").replace(/\s/g, ""), className: "text-black" }, location.attributes.shopPhone))) : null),
                    mapMarker && (React.createElement("div", { className: "flex flex-no-wrap w-full items-center justify-start pb-4" },
                        React.createElement("span", { className: "" },
                            React.createElement("a", { href: "https://www.google.com/maps?saddr=My+Location&daddr=" + location.attributes.address1 + "+" + location.attributes.suburb + "+" + location.attributes.state + "+" + location.attributes.postcode, target: "_blank", className: "underline uppercase text-primary text-xs tracking-wider font-medium text-black", title: location.attributes.shopName, rel: "noreferrer" }, "Directions")))))));
        };
        _this.calculateOpenHours = function (hours) {
            if (!hours) {
                return null;
            }
            var today = new Date();
            var currentWeekday = today.getDay();
            var result = today.getDay();
            var currentDays = hours.filter(function (openHours) {
                return openHours.dayStart !== null &&
                    openHours.dayEnd !== null &&
                    openHours.timeEnd !== null &&
                    currentWeekday !== null &&
                    openHours.dayStart <= currentWeekday &&
                    openHours.dayEnd >= currentWeekday;
            });
            return currentDays.length ? currentDays[0] : null;
        };
        _this.calculateDistanceBetween = function (from, to, unit) {
            if (!from || !to) {
                return "";
            }
            var lat1 = from.lat;
            var lng1 = from.lng;
            var lat2 = to.lat;
            var lng2 = to.lon;
            if (!lat1 || !lng1 || !lat2 || !lng2) {
                return null;
            }
            if (lat1 == lat2 && lng1 == lng2) {
                return "0";
            }
            var radlat1 = (Math.PI * lat1) / 180;
            var radlat2 = (Math.PI * lat2) / 180;
            var theta = lng1 - lng2;
            var radtheta = (Math.PI * theta) / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            dist > 1 ? (dist = 1) : null;
            dist = Math.acos(dist);
            dist = (dist * 180) / Math.PI;
            dist = dist * 60 * 1.1515;
            return unit == "mi" ? "" + (dist * 0.8684).toFixed(1) : "" + (dist * 1.609344).toFixed(1);
        };
        return _this;
    }
    StoreDetail.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, currentStore;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, reactive_storelocator_1.DeveloperToolkit.fetchConfig("/apps/toolkit/store-locator/configuration")];
                    case 1:
                        _a.storeLocatorDeveloperToolkitConfig = _b.sent();
                        return [4 /*yield*/, reactive_storelocator_1.DeveloperToolkit.fetchData(this.storeLocatorDeveloperToolkitConfig, {
                                query: {
                                    bool: {
                                        must: [
                                            {
                                                match_all: {}
                                            },
                                            {
                                                match: {
                                                    id: new URLSearchParams(window.location.search).get("location")
                                                }
                                            }
                                        ]
                                    }
                                }
                            })];
                    case 2:
                        currentStore = (_b.sent())[0];
                        this.storeLocator = new reactive_storelocator_1.StoreLocator({
                            googleMapsApiKey: this.storeLocatorDeveloperToolkitConfig.googleMapsAPIKey,
                            googleMapsApiVersion: "3.37",
                            fetchData: function (query) {
                                return reactive_storelocator_1.DeveloperToolkit.fetchData(_this.storeLocatorDeveloperToolkitConfig, reactive_storelocator_1.StoreLocator.buildElasticsearchQuery(5, 0, query));
                            },
                            parseData: function (locations) {
                                return locations.map(function (location) { return ({
                                    id: location.id,
                                    title: location.shopName,
                                    icon: "data:image/svg+xml;charset=UTF-8;base64," + btoa(Snippets.Svg.toString({ name: "pin", width: 36 })),
                                    position: {
                                        lat: location.location.lat,
                                        lng: location.location.lon
                                    },
                                    attributes: location
                                }); });
                            }
                        });
                        this.setState({
                            currentStore: currentStore,
                            currentLocation: {
                                lat: currentStore.location.lat,
                                lng: currentStore.location.lon
                            },
                            loading: false
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreDetail.prototype.formatHours = function (time) {
        var formatted = next_components_1.ShopifyNext.Utils.formatDate("01/01/2000 " + time.toString().slice(0, -2) + ":" + time.toString().slice(-2), "hh:mma");
        if (formatted.startsWith("0")) {
            formatted = formatted.slice(1);
        }
        return time;
    };
    StoreDetail.prototype.buildOpenHours = function (hours) {
        return hours.map(function (openHours, i) { return (React.createElement("p", { key: i, className: "flex" },
            next_components_1.ShopifyNext.Utils.formatDayNumber(openHours.dayStart, false).slice().slice(0, 3),
            " -",
            " ",
            next_components_1.ShopifyNext.Utils.formatDayNumber(openHours.dayEnd, false).slice(0, 3),
            "\u00A0\u00A0",
            React.createElement("span", null,
                next_components_1.ShopifyNext.Utils.formatDate("01/01/2000 " + openHours.timeStart.toString().slice(0, -2) + ":" + openHours.timeStart.toString().slice(-2), "hh:mma"),
                " ",
                "-",
                " "),
            React.createElement("span", null,
                " ",
                next_components_1.ShopifyNext.Utils.formatDate("01/01/2000 " + openHours.timeEnd.toString().slice(0, -2) + ":" + openHours.timeEnd.toString().slice(-2), "hh:mma")))); });
    };
    StoreDetail.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return null;
        }
        return (React.createElement(reactive_storelocator_1.StoreLocator.Provider, { storeLocator: this.storeLocator },
            React.createElement("div", { className: "mx-auto", key: "detail" },
                React.createElement(Snippets.Container, { tag: "section", collapsed: true, className: "hidden md:block py-1-4 mlg:px-11 md:px-2-4", width: "xl" },
                    React.createElement("ul", { className: "list-reset flex items-center justify-start text-xs font-normal" },
                        React.createElement("li", null,
                            React.createElement("a", { href: "/", title: "Home", className: "flex items-center justify-start no-underline transition-fast text-navy-dark hover:text-navy" },
                                React.createElement("p", { className: "text-xs" }, "Home"),
                                React.createElement(Snippets.Svg, { name: "chevron-right", width: 10, className: "block mr-0-4 text-blue-grey" }))),
                        React.createElement("li", null,
                            React.createElement("a", { href: "/pages/store-locator", title: "Store Locator", className: "flex items-center justify-start no-underline transition-fast text-navy-dark hover:text-navy" },
                                React.createElement("p", { className: "text-xs" }, "Store Locator"),
                                React.createElement(Snippets.Svg, { name: "chevron-right", width: 10, className: "block mr-0-4 text-blue-grey" }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "flex items-center justify-start no-underline text-navy capitalize" }, this.state.currentStore.shopName)))),
                React.createElement("section", { className: "mx-auto max-w-xl flex flex-wrap justify-center mt-2" },
                    React.createElement("div", { className: "lg:w-1/3 lg:pr-2 w-full md:mb-0 mb-2" },
                        React.createElement("div", { className: "w-full" },
                            React.createElement(reactive_storelocator_1.StoreLocator.List, null, function (location, selected) {
                                return location.id !== _this.state.currentStore.id ? null : (React.createElement("div", { key: location.id },
                                    React.createElement("div", { className: "md:px-4-8 px-1-6" },
                                        React.createElement(Snippets.Heading, { size: "h4", tag: "h4", className: "font-extrabold tracking-none leading-tight mb-1-6" }, location.attributes.shopName),
                                        React.createElement("ul", { className: "list-reset" },
                                            location.attributes.address1 ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                                                React.createElement("span", { className: "min-w-3 h-3 flex justify-center items-center rounded-full bg-navy text-arctic mr-0-8" },
                                                    React.createElement(Snippets.Svg, { name: "location", width: 16 })),
                                                React.createElement("span", { className: "text-navy-dark text-base" },
                                                    location.attributes.address1,
                                                    location.attributes.address2 ? location.attributes.address2 : null))) : null,
                                            location.attributes.shopPhone ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                                                React.createElement("span", { className: "min-w-3 h-3 flex justify-center items-center rounded-full bg-navy text-arctic mr-0-8" },
                                                    React.createElement(Snippets.Svg, { name: "phone", width: 14 })),
                                                React.createElement("span", { className: "text-navy-dark text-base" }, location.attributes.shopPhone))) : null,
                                            location.attributes.website ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                                                React.createElement("span", { className: "min-w-3 h-3 flex justify-center items-center rounded-full bg-navy text-arctic mr-0-8" },
                                                    React.createElement(Snippets.Svg, { name: "mail", width: 14 })),
                                                React.createElement("span", { className: "text-navy-dark text-base" }, location.attributes.website))) : null,
                                            location.attributes.openHours && location.attributes.openHours.length > 0 ? (React.createElement("li", { className: "flex items-center mb-1-6" },
                                                React.createElement("span", { className: "min-w-3 h-3 flex justify-center items-center rounded-full bg-navy text-arctic mr-0-8" },
                                                    React.createElement(Snippets.Svg, { name: "clock", width: 14 })),
                                                React.createElement("p", { className: "text-navy-dark text-base" }, _this.buildOpenHours(location.attributes.openHours)))) : null),
                                        React.createElement(Snippets.Button, { style: "chevron", href: "https://www.google.com/maps?saddr=My+Location&daddr=" + location.attributes.address1 + "+" + location.attributes.suburb + "+" + location.attributes.state + "+" + location.attributes.postcode, className: "hidden md:flex items-center px-2-4 font-medium mb-0-1 bg-navy text-arctic h-4-8 font-extrabold tracking-none rounded flex items-center", target: "_blank" }, "Get Directions"),
                                        React.createElement("ul", { className: "list-reset mt-2" }, location.attributes.customOptions
                                            ? Object.values(location.attributes.customOptions).map(function (customOption) {
                                                if (customOption && customOption != "" && typeof customOption != "boolean") {
                                                    return (React.createElement("li", { className: "flex items-center mb-1-6" },
                                                        React.createElement("span", { className: "min-w-3 h-3 flex justify-center items-center rounded-full bg-navy text-arctic mr-0-8" },
                                                            React.createElement(Snippets.Svg, { name: "clock", width: 14 })),
                                                        React.createElement("p", { className: "text-navy-dark text-base" }, customOption)));
                                                }
                                            })
                                            : null))));
                            }))),
                    React.createElement("div", { className: "w-full lg:w-2/3 bg-very-light-pink" },
                        React.createElement(reactive_storelocator_1.StoreLocator.Map, { style: {
                                width: "100%",
                                height: "400px"
                            }, clusterOptions: {
                                styles: [
                                    {
                                        textColor: "white",
                                        url: reactive_storelocator_1.clusterPinBuilder("#003057"),
                                        height: 50,
                                        width: 50
                                    }
                                ],
                                maxZoom: 11,
                                averageCenter: true,
                                zoomOnClick: false
                            }, googleMapsOptions: {
                                center: {
                                    lat: this.state.currentStore.location.lat,
                                    lng: this.state.currentStore.location.lon
                                },
                                zoom: 14,
                                maxZoom: 14,
                                zoomControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: false,
                                draggable: false,
                                styles: this.storeLocatorDeveloperToolkitConfig.googleMapsJSONStyle
                            }, infowindowContent: function (location) { return (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "w-21" }, _this.renderLocationInfoWindow(location, false)))); } }),
                        React.createElement("section", { className: "w-full pt-2-4 pb-4-4 md:px-3-2 px-1-6" },
                            React.createElement("div", { className: "w-full" },
                                React.createElement(Snippets.Heading, { size: "h4", tag: "h4", className: "font-semibold text-navy-dark tracking-none leading-tight mb-1-6" }, "Nearby Stores"),
                                React.createElement("div", { className: "flex flex-wrap  md:-mx-1-2" },
                                    React.createElement(reactive_storelocator_1.StoreLocator.List, null, function (location) {
                                        if (location.id === _this.state.currentStore.id) {
                                            return null;
                                        }
                                        return (React.createElement("div", { className: "md:w-1/2 w-full md:px-1-2 pb-1-6 min-h-20", key: location.id },
                                            React.createElement("div", { className: "w-full shadow-block flex items-stretch bg-arctic h-full" },
                                                React.createElement("div", { className: "w-3/10 flex flex-col justify-center items-center bg-very-light-pink height-full py-4-8" },
                                                    React.createElement("p", { className: "w-full text-navy-dark text-36 text-center font-extrabold leading-lesstight" }, _this.state.currentLocation
                                                        ? _this.calculateDistanceBetween(_this.state.currentLocation, location.attributes.location, "km")
                                                        : null),
                                                    React.createElement("span", { className: "text-navy-dark block text-center w-full text-sm font-semibold" }, "km")),
                                                React.createElement("div", { className: "w-7/10 pl-2-4 py-1-6 flex flex-col" },
                                                    React.createElement(Snippets.Heading, { size: "h4", tag: "h3", className: "font-semibold tracking-none mb-0-4" },
                                                        location.attributes.shopName,
                                                        location.attributes.shopType == "warehouse" ? " (Outlet)" : null),
                                                    React.createElement("div", { className: "flex-1" },
                                                        location.attributes.address1 ? (React.createElement("p", { className: "text-grey-dark text-base leading-tight" }, location.attributes.address1)) : null,
                                                        location.attributes.address2 ? (React.createElement("p", { className: "text-grey-dark text-base leading-tight" }, location.attributes.address2)) : null,
                                                        React.createElement("p", { className: "text-grey-dark text-base leading-tight" },
                                                            location.attributes.suburb ? (React.createElement("span", null,
                                                                location.attributes.suburb,
                                                                "\u00A0")) : null,
                                                            location.attributes.state ? (React.createElement("span", null,
                                                                location.attributes.state,
                                                                "\u00A0")) : null,
                                                            location.attributes.postcode ? (React.createElement("span", null,
                                                                location.attributes.postcode,
                                                                "\u00A0")) : null)),
                                                    React.createElement("a", { href: "/pages/store?location=" + location.id, className: "block md:inline-block relative underline font-extrabold text-base" }, "View Details")))));
                                    })))))))));
    };
    return StoreDetail;
}(React.Component));
exports.StoreDetail = StoreDetail;
